<template>

    <div class="c-rkw-bookmark-modal" :class="{'c-rkw-bookmark-modal--open': open === true}">

        <div class="c-rkw-bookmark-modal__wrapper">
            <div class="o-container">
                <a href="#" class="logo"></a>
                <a href="#" class="c-rkw-bookmark-modal__close" @click.prevent="toggleBookmarkModal"></a>
                <header class="c-rkw-bookmark-modal__header">
                    <h2 class="c-rkw-bookmark-modal__headline">
                        Beispiele Merkliste
                        <span style="vertical-align: text-top;" v-if="entries.length">({{entries.length}})</span>
                    </h2>
                    <div class="c-rkw-bookmark-modal__share-container">
                        <span :class="['c-rkw-bookmark-modal__share-item c-rkw-bookmark-modal__share-item--disk']" @click.prevent="saveList=true" data-title="Merkliste speichern" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }"></span>
                    </div>
                    <div class="c-rkw-bookmark-modal__share-container c-rkw-bookmark-modal__share-container--bottom">
                        <span class="c-rkw-bookmark-modal__share-label">Teilen: </span>
                        <a :href="sharing.xing + urlToShare" target="_blank" class="c-rkw-bookmark-modal__share-item c-rkw-bookmark-modal__share-item--xing"></a>
                        <a :href="sharing.facebook + urlToShare" target="_blank" class="c-rkw-bookmark-modal__share-item c-rkw-bookmark-modal__share-item--facebook"></a>
                        <a :href="sharing.twitter + urlToShare" target="_blank" class="c-rkw-bookmark-modal__share-item c-rkw-bookmark-modal__share-item--twitter"></a>
                        <a :href="sharing.linkedin + urlToShare" target="_blank" class="c-rkw-bookmark-modal__share-item c-rkw-bookmark-modal__share-item--linkedin"></a>
                        <a :href="sharing.mail + urlToShare" class="c-rkw-bookmark-modal__share-item c-rkw-bookmark-modal__share-item--email"></a>
                    </div>
                </header>
                <div class="o-grid">
                    <transition name="fade">
                        <div v-if="!entries.length" class="o-grid__col u-12/12">
                            <p class="c-rkw-bookmark-modal__empty-info">
                                Sie haben aktuell noch keine Beispiele in der Merkliste hinterlegt.
                            </p>
                        </div>
                    </transition>

                    <div v-if="entries.length" class="o-grid__col u-12/12">
                        <div v-for="(_entries, _modelID, index) in pEntries" class="c-rkw-bookmark-modal__group" v-if="_entries.length">
                            <div class="o-grid">
                                <h3 :class="`c-rkw-bookmark-modal__group-header c-rkw-bookmark-modal__group-header${models[_modelID].color} o-grid__col u-12/12`">
                                    {{models[_modelID].title}}
                                </h3>
                            </div>

                            <div class="c-rkw-bookmark-modal__group-items o-grid">
                                <div v-for="entry in _entries" class="o-grid__col u-3/12 u-2/4@mobile" v-if="getContentModel(entry).id === models[_modelID].id">
                                    <transition name="fade" v-on:after-leave="afterLeave">
                                        <div v-if="entry !== removing" :class="`c-rkw-bookmark-modal__bookmark c-rkw-bookmark-modal__bookmark${getContentColor(entry)}`" :style="`background-image: url(${settings.pageUrl}${getBookmarkContent(entry).sliderImages[0][1]});`" @click.prevent="openContentModal(entry)">
                                            <span class="c-rkw-bookmark-modal__bookmark-remove" v-on:click.stop="removeQueue(entry)" data-title="Beispiel entfernen" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }"></span>
                                            <span class="c-rkw-bookmark-modal__bookmark-text">
                                                <strong>{{getBookmarkContent(entry).content.header}}</strong><br><br>
                                                {{getBookmarkContent(entry).content.subheader}}
                                            </span>
                                        </div>
                                    </transition>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="c-rkw-bookmark-modal__save-list" v-if="saveList">
                <div class="c-rkw-bookmark-modal__save-list-container">
                    <a href="#" class="c-rkw-bookmark-modal__close c-rkw-bookmark-modal__close--save-list" @click.prevent="saveList=false"></a>
                    <h3 class="c-rkw-bookmark-modal__save-list-header">Merkliste speichern</h3>
                    <p class="c-rkw-bookmark-modal__save-list-body">Die Merkliste wird per Cookie in ihrem Browser gespeichert und ist beim nächsten Aufruf verfügbar. Mit der folgenden URL, können Sie ihre Merkliste jederzeit auch auf anderen Geräten und Browsern aufrufen und/oder an dritte Personen weiterleiten.</p>
                    <p class="c-rkw-bookmark-modal__save-list-url">{{decodeURIComponent(getUrl(false))}}</p>
                    <div style="text-align: center; margin-bottom: 1rem;">
                        <span class="c-rkw-content__button c-rkw-content__button--bookmark-copy-url" @click.prevent="copyLink">URL in Zwischenablage kopieren</span>
                    </div>
                    <div style="text-align: center;">
                        <a class="c-rkw-content__button c-rkw-content__button--bookmark-send-email" :href="sharing.mail + getUrl(true)">URL als Email versenden</a>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>

    import mixins from "../mixins"

    export default {
        data () {
            return {
                removing: null,
                copied: false,
                saveList: false,
                sharing: {
                    twitter: 'https://twitter.com/intent/tweet?url=',
                    facebook: 'https://www.facebook.com/sharer.php?u=',
                    linkedin: 'https://www.linkedin.com/shareArticle?mini=true&title=RKW Digi-Cockpit Bookmark&url=',
                    xing: 'https://www.xing.com/spi/shares/new?url=',
                    mail: 'mailto:Empfänger eingeben?subject=RKW Digi-Cockpit Bookmark&body='
                },
                urlToShare: document.URL
            }
        },
        computed: {
            settings () {
                return this.$store.state.settings
            },
            open () {
                return this.$store.state.runtime.bookmarks.open
            },
            entries () {
                return this.$store.state.runtime.bookmarks.entries
            },
            pEntries () {
                let obj = {}
                for(let modelKey in this.models) {
                    if(this.models.hasOwnProperty(modelKey)) {
                        obj[modelKey] = []
                    }
                }
                for (let i = 0; i < this.entries.length; i++) {
                    let model = this.getContentModel(this.entries[i])
                    obj['uid' + model.id].push(this.entries[i])
                }
                return obj
            },
            models () {
                return this.$store.state.data.models
            }
        },
        beforeMount: function() {
            if(this.$route.name === "bookmarks") {
                this.$store.commit('toggleBookmarkModal')
            }

            if(this.$route.name === "bookmarkEntries" && this.$route.params.entries) {
                if(typeof JSON.parse(this.$route.params.entries) === "object") {
                    let storage = window.localStorage
                    storage.setItem('rkw-digi_bookmarks', this.$route.params.entries)
                    this.$store.commit('toggleBookmarkModal')
                }
            }


            let storage = window.localStorage
            let bookmarks = storage.getItem('rkw-digi_bookmarks')
            if(bookmarks !== null && bookmarks.indexOf('[') !== -1 && typeof JSON.parse(bookmarks) === "object") {
                this.$store.commit('updateBookmarks', bookmarks)
            }
        },
        beforeCreate () {

        },
        watch: {
            '$store.state.runtime.bookmarks.entries': function(val, old) {
                let storage = window.localStorage
                storage.setItem('rkw-digi_bookmarks', JSON.stringify(this.entries))

                this.urlToShare = this.createSharingUrl()
            },
            'open' () {
                if(this.open) {
                    router.push({path: '/bookmarks', name: 'bookmarks'})
                } else {
                    if(this.$store.state.runtime.activeItems.instance) {
                        this.pushInstanceRoute(this.$store.state.runtime.activeItems.instance)
                    } else {
                        router.push({path: '/', name: 'home'})
                    }
                }
            },
            '$route' () {
                if(this.$route.name === "bookmarks" && !this.open) {
                    this.$store.commit('toggleBookmarkModal')
                }
            }
        },
        mixins: [mixins],
        methods: {
            openContentModal (uid) {
                this.$store.commit('closeBookmarkModal')
                this.setActiveInstance(uid)
            },
            removeQueue (uid) {
                this.removing = uid
            },
            afterLeave () {
                this.removeBookmark(this.removing)
                this.removing = null
            },
            copyLink () {
                let e = JSON.stringify(this.entries)
                let uri = global.host.uri + '#/bookmarks/entries/' + e
                this.clipboard(uri)
                this.saveList = false
            },
            createSharingUrl () {
                return global.host.uri + encodeURIComponent('#/bookmarks/entries/' + JSON.stringify(this.entries))
            },
            clipboard(text) {
                if (window.clipboardData && window.clipboardData.setData) {
                    // IE specific code path to prevent textarea being shown while dialog is visible.
                    return clipboardData.setData("Text", text);

                } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                    var textarea = document.createElement("textarea");
                    textarea.textContent = text;
                    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                    } catch (ex) {
                        console.warn("Copy to clipboard failed.", ex);
                        return false;
                    } finally {
                        document.body.removeChild(textarea);
                    }
                }
            },
            getUrl(encode) {
                let e = JSON.stringify(this.entries)
                return global.host.uri + ((encode === true) ? encodeURIComponent('#/bookmarks/entries/' + e) : '#/bookmarks/entries/' + e)
            },
            setBrowserBookmark ($event) {
                let e = JSON.stringify(this.entries)
                let uri = global.host.uri + '#/bookmarks/entries/' + e

                if (window.sidebar && window.sidebar.addPanel) { // Firefox <23

                    window.sidebar.addPanel(document.title,uri,'');

                } else if(window.external && ('AddFavorite' in window.external)) { // Internet Explorer

                    window.external.AddFavorite(uri,document.title);

                } else if(window.opera && window.print || window.sidebar && ! (window.sidebar instanceof Node)) { // Opera <15 and Firefox >23
                    /**
                     * For Firefox <23 and Opera <15, no need for JS to add to bookmarks
                     * The only thing needed is a `title` and a `rel="sidebar"`
                     * To ensure that the bookmarked URL doesn't have a complementary `#` from our trigger's href
                     * we force the current URL
                     */
                    //$event.currentTarget.attr('rel', 'sidebar').attr('title', document.title).attr('href', window.location.href);
                    return true;

                } else { // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D

                    alert('You can add this page to your bookmarks by pressing ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? 'Command/Cmd' : 'CTRL') + ' + D on your keyboard.');

                }
                // If you have something in the `href` of your trigger
                return false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// BookmarkModal.vue?5244e18c